/*###########################################################################
// Header
//#########################################################################*/

import { animate } from "motion"

export default function header() {
  return {
    menuOpen: false,
    appDownloadOpen: false,
    rotate: 0,
    scale: 1,
		hasScrolled: false,
		_menuItemAnims: [],
		currentPath: window.location.pathname || '/',

    init() {
      const self = this

      this._onScroll = () => {
        const y = window.scrollY || window.pageYOffset || 0

				if (y > 10) {
					this.hasScrolled = true
				} else {
					this.hasScrolled = false
				}

				if (window.innerWidth >= 1024) {
					const rot = (y / 2000) * 360
					this.rotate = rot
					let s = 1 - (y / 2000) * (1 - 0.33)
					if (s < 0.33) s = 0.33
					if (s > 1) s = 1
					this.scale = s
				}
      }

      window.addEventListener('scroll', this._onScroll, { passive: true })
      this._onScroll()

      if (import.meta && import.meta.hot && import.meta.hot.dispose) {
        import.meta.hot.dispose(() => {
          window.removeEventListener('scroll', this._onScroll)
        })
      }

			this.$watch('menuOpen', () => {
				this.handleAnimation()
			})

			// Set current nav item
			//
			self.setNavItems()

			// Set nav items on barba transition
			//
			window.addEventListener('page-change', function() {
				self.setNavItems()
			})

			// Set current path after page url updates
			//
			window.addEventListener('after-page-change', function() {
				self.currentPath = window.location.pathname || '/'
			})
    },

    menuToggle() {
      this.menuOpen = !this.menuOpen

      document.documentElement.style.overflow = this.menuOpen ? 'hidden' : ''
      if (!this.menuOpen) {
        setTimeout(() => {
          document.documentElement.style.overflow = ''
        }, 400)
      }
    },

    appDownloadToggle() {
			this.menuOpen = false
      this.appDownloadOpen = !this.appDownloadOpen
      document.documentElement.style.overflow = this.appDownloadOpen ? 'hidden' : ''
      if (!this.appDownloadOpen) {
        setTimeout(() => {
          document.documentElement.style.overflow = ''
        }, 300)
      }
    },

    closeMenu() {
			this.handleAnimation()

      if (this.menuOpen) {
        this.menuOpen = false
        document.documentElement.style.overflow = ''
      }
    },

    menuButtonClass() {
      let cls = 'bg-white border-[#B4C0C6]'

      if (this.menuOpen) {
        cls = 'bg-white border-white'
      } else {
        const p = this.currentPath || ''
        if (p.includes('/news') || p.includes('/policies')) {
          cls = 'bg-white border-black'
        }
      }

      return cls
    },

    appButtonClass() {
      let cls = 'bg-white border border-[#B4C0C6] text-black'

      if (this.menuOpen) {
        cls = 'bg-[#EBEA33] border border-[#EBEA33] text-black'
      } else {
        const p = this.currentPath || ''
        if (p.includes('/news') || p.includes('/policies')) {
          cls = 'bg-white border border-black text-black'
        }
      }

      return cls
    },

    logoClass() {
      let cls = 'text-white'

      if (this.menuOpen) {
        cls = 'text-yellow'
      } else {
        const p = this.currentPath || ''
        if (p.includes('/news') || p.includes('/policies')) {
          cls = 'text-black'
        }
      }

      return cls
    },

    logoStyle() {
      return {
        transform: `scale(${this.scale})`,
        transition: 'transform 150ms linear',
      };
    },

    logoInnerStyle() {
      return {
        transform: `rotateZ(${this.rotate}deg)`,
        transition: 'transform 150ms linear',
      };
    },

		setNavItems() {
			const self = this

			const items = document.querySelectorAll('.header__nav__item')

			self.resetNavItems(items)

			for (let i = 0; i < items.length; i++) {
				const item = items[i]
				const path = item.getAttribute('data-path')

				self.setCurrentNavItem(item, path)
			}
		},

    setCurrentNavItem(item, path) {
      const currentPath = window.location.pathname || '/'

      if (currentPath === path) {
				item.classList.add('header__nav__item--current')
			}
		},

		resetNavItems(items) {
			for (let i = 0; i < items.length; i++) {
				const item = items[i]
				item.classList.remove('header__nav__item--current')
			}
		},

		handleAnimation() {
			const self = this

			const menuEl = document.querySelector('#site-header')
      if (!menuEl) return

      if (this._menuAnim && typeof this._menuAnim.stop === 'function') this._menuAnim.stop()
      this._menuItemAnims.forEach(a => { if (a && typeof a.stop === 'function') a.stop(); })
      this._menuItemAnims = []

      const ease = [0.71, 0, 0.17, 1]
      const baseDelay = 0.2

			const headerLogo = menuEl.parentNode.querySelector('.logo-svg')
			const headerLogoProps = this.menuOpen ? { rotate: 360 } : { rotate: 0 }
			animate(headerLogo, headerLogoProps, {
				duration: 0.1,
				ease: ease,
				fill: 'both'
			})

			const headerCircle = menuEl.parentNode.querySelector('.header-overlay__circle')
			const headerCircleSequence = this.menuOpen ? [
				[headerCircle, { opacity: 1 }, { duration: 0.05 }],
				[headerCircle, { scale: 100 }, { duration: 0.75, ease: ease }]
			] : [
				[headerCircle, { scale: 0 }, { duration: 0.75, ease: ease }],
				[headerCircle, { opacity: 0 }, { duration: 0.05 }]
			]

			animate(headerCircleSequence)

      const items = Array.from(menuEl.parentNode.querySelectorAll('.header__nav__item'))
      const stagger = 0.025
      items.forEach((it, idx) => {
        const extraOpenOffset = this.menuOpen ? 0.05 : 0
        const itemDelay = this.menuOpen ? baseDelay + idx * stagger + extraOpenOffset : 0
        const itemDuration = this.menuOpen ? 0.55 : 0.33

        const props = this.menuOpen ? { y: ['100%', 0], opacity: [0, '100%'] } : { y: [0, '100%'], opacity: [1, 0] }

        const anim = animate(it, props, {
          duration: itemDuration,
          delay: itemDelay,
          ease: ease,
          fill: 'both'
        })

        this._menuItemAnims.push(anim)
      })
		}
  }
}
